<template>
  <div>
    <v-container container--fluid grid-list-md>
      <v-row justify="space-between">
        <h1 class="text-little mt-2 ml-4">Templates Manager</h1>
      </v-row>
      <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
        <v-col cols="9" sm="9" md="3">
          <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
        </v-col>
        <v-col
          cols="4"
          sm="3"
          md="2"
          class="text-center"
        >
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn @click="newTemplate" class="mx-2" fab dark color="blue lighten-1" v-on="on">
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <span>Create a new Template</span>
          </v-tooltip>
        </v-col>
      </v-row>

    </v-container>

    <v-divider color="#42a5f5"></v-divider>

    <v-data-table
      :headers="header"
      :search="search"
      :items="renderedTemplates"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="selectRow(item)">
          <v-icon>edit</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.template="{ item }">
        <v-btn icon @click="renderRow(item)">
          <v-icon>fas fa-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      v-model="createDialog"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit template' : 'New templates' }}</h3>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="keyItem.name"
            label="Name"
            hint="Needs to be unique"
          ></v-text-field>

          <v-select
            v-model="keyItem.type"
            :items="typeList"
            label="Type"
          ></v-select>

          <v-col class="mb-3 pa-0">
            <v-col class="mb-3 pa-0">
              <p class="mb-0">Template</p>
            </v-col>
            <prism-editor
              style="max-height: 400px"
              v-model="keyItem.template"
              language="js"
              line-numbers
              class="editor"
            ></prism-editor>
          </v-col>

          <v-col class="mb-3 pa-0">
            <v-col class="mb-3 pa-0">
              <p class="mb-0">Sample</p>
            </v-col>
            <prism-editor
              style="max-height: 400px"
              v-model="keyItem.sample"
              language="js"
              line-numbers
              class="editor"
            ></prism-editor>
          </v-col>

        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeCreateDialog"
            color="blue-grey lighten-2"
          >Cancel
          </v-btn>
          <v-btn
            text
            @click="saveChanges"
            color="blue darken-1"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="templatePreview" max-width="600px">
      <v-card class="pa-5">
        <div class="preview"></div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import axios from "axios";
  import PrismEditor from 'vue-prism-editor'

  export default {
    name: "Templates",
    components: {PrismEditor},
    data() {
      return {
        reload: false,
        loading: false,
        createDialog: false,
        templatePreview: false,

        typeList: ["html", "pdf", "csv", "label"],
        keyItem: {
          name: null,
          type: null,
          template: null,
          sample: null
        },
        editedIndex: -1,
        search:'',
      }
    },
    methods:{
      updateDataTable() {
        this.reload = !this.reload;
      },
      newTemplate() {
        this.editedIndex = -1;
        this.keyItem = Object.assign({}, this.default);
        this.createDialog = true;
      },
      closeCreateDialog(){
        this.createDialog = false;
      },
      saveChanges(){
        let body = this.keyItem;
        if (this.editedIndex === -1){
          axios.post(process.env.API_URL + '/templates', body)
            .then((response) => {
              this.$store.commit('displaySnackbar', 'Create successful');
              this.updateDataTable();
              this.closeCreateDialog();
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            })
        } else {
          axios.put(process.env.API_URL + '/templates/' + this.editedIndex, body)
            .then(() => {
              this.$store.commit('displaySnackbar', 'Edited successful');
              this.updateDataTable();
              this.closeCreateDialog();
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            })
        }
      },
      selectRow(item){
        this.editedIndex = item.id;
        this.keyItem = Object.assign({}, item);
        this.createDialog = true;
      },
      renderRow(item){
        const templateId = item.id;
        if (item.type === 'pdf') {
          axios({
            url: process.env.API_URL + '/templates/' + templateId + '/render',
            method: 'POST',
            responseType: 'blob',
          })
            .then((response) => {
              var url = URL.createObjectURL(response.data);
              window.open(url, '_blank');
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', 'ERROR: Render template failed');
            });
        } else {
          axios.post(process.env.API_URL + '/templates/' + templateId + '/render')
            .then((response) => {
              this.$store.commit('displaySnackbar', 'Render successful');
              this.templatePreview = true;
              document.querySelector('.preview').innerHTML = response.data;
              console.log(response);
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            })
        }
      }
    },
    computed: {
      renderedTemplates() {
        if (this.Templates === null || this.Templates === undefined){
          return [];
        } else {
          return this.Templates;
        }
      },
      header(){
        let headers = [
          {text: 'Id', value: 'id', align: 'center'},
          {text: 'Name', value: 'name', align: 'center'},
          {text: 'Type', value: 'type', align: 'center'},
          {text: 'Template', value: 'template', align: 'center'},
          // {text: 'Sample', value: 'sample', align: 'center'},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ];
        return headers;
      }
    },
    asyncComputed: {
      async Templates() {
        if (this.reload || !this.reload) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/templates' )
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((response) => {
              this.loading = false;
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            });
        }
      }
    }
  }
</script>

<style>
  .prism-editor-wrapper code{
    background-color: transparent;
    box-shadow: none;
  }
  .prism-editor-wrapper{
    background-color: rgb(45,45,45);
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Templates.vue